import styled from 'styled-components';
import { Modal } from '@trackman/web-shared-components';
import React from 'react';

export const ModalContent = styled.div`
  padding: 24px 32px;
  font-size: 15px;
  line-height: 21px;
`;

export const Title = styled.div`
  font-weight: 700;
  margin-top: 16px;
`;

export const StyledModal = styled((props) => <Modal {...props} />)`
  &&& {
    .MuiPaper-root {
      max-width: 709px;
    }

    .onlyConfirm {
      justify-content: flex-end;
    }
  }
`;
